export const useModelsVisibilityTemplatesFilters = (
  templates, isActiveOwner, isActiveClients, isActiveCommunity
) => {
  let filteredVisibilityTemplates = [];

  if (
    (isActiveOwner === false && isActiveClients === true && isActiveCommunity === true) ||
    (isActiveOwner === false && isActiveClients === false && isActiveCommunity === true) ||
    (isActiveOwner === false && isActiveClients === true && isActiveCommunity === false)
  ) {
    const filteredVisibilityList = templates?.filter((templ) => {
      return templ.availableTo === "managed";
    });
    filteredVisibilityTemplates = [...filteredVisibilityList];
  }

  if (
    (isActiveOwner === true && isActiveClients === true && isActiveCommunity === false) ||
    (isActiveOwner === true && isActiveClients === false && isActiveCommunity === true)
  ) {
    const filteredVisibilityList = templates?.filter((templ) => {
      return templ.availableTo === "managed" || "owner";
    });
    filteredVisibilityTemplates = [...filteredVisibilityList];
  }

  if (isActiveOwner === true && isActiveClients === false && isActiveCommunity === false) {
    const filteredVisibilityList = templates?.filter((templ) => {
      return templ.availableTo === "owner";
    });
    filteredVisibilityTemplates = [...filteredVisibilityList];
  }

  if (isActiveOwner === false && isActiveClients === false && isActiveCommunity === false) {
    const filteredVisibilityList = [];
    filteredVisibilityTemplates = [...filteredVisibilityList];
  }

  return filteredVisibilityTemplates;
};
